import React from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "@config/config";
import { useDuplicateProductMutation } from "@queries/catalog";

export default function ProductsTable({ rows, selected, onToggle, onToggleAll }) {
  const base = config.imageBaseUrl || "";
  const navigate = useNavigate();
  const duplicate = useDuplicateProductMutation();
  const [duplicatingId, setDuplicatingId] = React.useState(null);

  function handleDuplicate(id) {
    if (duplicatingId) return;
    setDuplicatingId(id);
    duplicate.mutate(id, {
      onSuccess: (res) => {
        const newId = res?.data?.id;
        if (newId) navigate(`/catalog/products/${newId}`);
      },
      onSettled: () => setDuplicatingId(null),
    });
  }

  const allChecked = rows.length > 0 && rows.every(p => selected.has(p.id));
  const someChecked = !allChecked && rows.some(p => selected.has(p.id));

  return (
    <div className="oc-table-wrap">
      <table className="oc-table">
        <thead>
          <tr>
            <th style={{ width: 36 }}>
              <input
                type="checkbox"
                checked={allChecked}
                ref={el => { if (el) el.indeterminate = someChecked; }}
                onChange={() => onToggleAll(rows.map(p => p.id))}
              />
            </th>
            <th style={{ width: 72 }}>Image</th>
            <th>Product Name</th>
            <th>Model</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Status</th>
            <th>Flagged</th>
            <th>Sewing</th>
            <th style={{ width: 80 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((p) => (
            <tr key={p.id} style={selected.has(p.id) ? { background: "#fef9ec" } : undefined}>
              <td>
                <input
                  type="checkbox"
                  checked={selected.has(p.id)}
                  onChange={() => onToggle(p.id)}
                />
              </td>

              <td>
                {p.image ? (
                  <img
                    src={`${base}${p.image}`}
                    alt=""
                    style={{
                      width: 48,
                      height: 48,
                      objectFit: "cover",
                      borderRadius: 6,
                      border: "1px solid #e5e7eb",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      border: "1px dashed #e5e7eb",
                      borderRadius: 6,
                    }}
                  />
                )}
              </td>

              <td>{p.name}</td>
              <td className="oc-mono" style={{ whiteSpace: "nowrap" }}>
                {p.model}
                <button
                  className="oc-ico-btn"
                  title="Duplicate (new copy will be disabled)"
                  disabled={duplicatingId === p.id}
                  onClick={() => handleDuplicate(p.id)}
                  style={{ marginLeft: 6, opacity: duplicatingId === p.id ? 0.5 : 1 }}
                >
                  {duplicatingId === p.id ? "⏳" : "📋"}
                </button>
              </td>
              <td className="oc-mono">{Number(p.price || 0).toFixed(2)} JOD</td>

              <td>
                <span className="oc-badge green">{p.quantity}</span>
              </td>

              <td>
                {String(p.status) === "1" ? (
                  <span className="oc-badge green">Enabled</span>
                ) : (
                  <span className="oc-badge gray">Disabled</span>
                )}
              </td>
              <td>
                {String(p.is_flagged) === "1" ? "🚩 Yes" : "No"}
              </td>
              <td>
                {String(p.is_sewing_flagged) === "1" ? "🧵 Yes" : "No"}
              </td>

              <td>
                <div className="oc-row-actions">
                  <Link to={`/catalog/products/${p.id}`}>
                    <button className="oc-ico-btn" title="Edit">✏️</button>
                  </Link>
                </div>
              </td>
            </tr>
          ))}

          {rows.length === 0 && (
            <tr>
              <td colSpan={10} style={{ textAlign: "center", padding: 24 }}>
                No products found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
